export default "__VITE_ASSET__DITnAaZZ__"